var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#333"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.138 3.276l-1.414-1.414L12 10.586 3.276 1.862 1.862 3.276 10.586 12l-8.724 8.724 1.414 1.414L12 13.414l8.724 8.724 1.414-1.414L13.414 12z"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHdpZHRoPSIyNHB4IiBoZWlnaHQ9IjI0cHgiIHZpZXdCb3g9IjAgMCAyNCAyNCIgIGZpbGw9IiMzMzMzMzMiPgo8cG9seWdvbiBwb2ludHM9IjIyLjEzOCwzLjI3NiAyMC43MjQsMS44NjIgMTIsMTAuNTg2IDMuMjc2LDEuODYyIDEuODYyLDMuMjc2IDEwLjU4NiwxMiAxLjg2MiwyMC43MjQgMy4yNzYsMjIuMTM4IDEyLDEzLjQxNCAyMC43MjQsMjIuMTM4IDIyLjEzOCwyMC43MjQgMTMuNDE0LDEyICIvPgo8L3N2Zz4K";
export { SvgClose as ReactComponent };